import { Pipe, PipeTransform } from '@angular/core';
import { TuiPoint } from '@taiga-ui/core';

@Pipe({
  name: 'coordonneesGraphique',
  standalone: true,
})
export class CoordonneesGraphiquePipe implements PipeTransform {
  transform(values: Array<number>): TuiPoint[] {
    return values
      .map((value, index) =>
        value !== null ? ([index, value] as TuiPoint) : null
      ) // Associe l'index et la valeur
      .filter((point): point is TuiPoint => point !== null); // Exclut les valeurs nulles
  }
}
